import { Pipe, PipeTransform } from '@angular/core';

import emojiRegex from 'emoji-regex';

@Pipe({
  name: 'emoji',
  standalone: false,
})
export class EmojisPipe implements PipeTransform {
  private static canvas: HTMLCanvasElement | null = null;
  private static ctx: CanvasRenderingContext2D | null = null;

  transform(text: string): string {
    if (!text) return text;
    const regex = emojiRegex();
    return text.replace(regex, (emoji) => {
      return this.isEmojiSupported(emoji) ? emoji : '☒';
    });
  }

  isEmojiSupported(emoji: string): boolean {
    const ctx = this.getCanvasContext();
    if (!ctx) return true;

    // Render emoji
    ctx.clearRect(0, 0, 32, 32);
    ctx.fillText(emoji, 0, 24);
    const emojiData = ctx.getImageData(0, 0, 32, 32).data;

    // Render replacement character (tofu)
    ctx.clearRect(0, 0, 32, 32);
    ctx.fillText('□', 0, 24);
    const tofuData = ctx.getImageData(0, 0, 32, 32).data;

    // Compare pixel data
    for (let i = 0; i < emojiData.length; i++) {
      if (emojiData[i] !== tofuData[i]) {
        return true; // Emoji is supported (renders differently)
      }
    }
    return false; // Emoji is not supported (renders same as tofu)
  }

  private getCanvasContext(): CanvasRenderingContext2D | null {
    if (!EmojisPipe.canvas) {
      EmojisPipe.canvas = document.createElement('canvas');
      EmojisPipe.canvas.width = EmojisPipe.canvas.height = 32;
      EmojisPipe.ctx = EmojisPipe.canvas.getContext('2d', { willReadFrequently: true });
      if (EmojisPipe.ctx) {
        EmojisPipe.ctx.font = '24px Arial, sans-serif';
      }
    }
    return EmojisPipe.ctx;
  }
}
